package com.flowyride.core.api

import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.speedcamera.SpeedCamera
import com.flowyride.core.domain.speedcamera.SpeedCameraType
import kotlinx.serialization.Serializable

/** Fixed speed cameras, kept up to date by the server. */
object SpeedCamerasApi {
    /** GET → [SpeedCameraDto] list. */
    const val PATH = "/api/speed-cameras"
}

/** [type] is a [SpeedCameraType] name, kept as text: unknown kinds read as UNKNOWN. */
@Serializable
data class SpeedCameraDto(
    val id: String,
    val type: String,
    val lat: Double,
    val lon: Double,
    /** Light vehicles' limit (what a motorcycle gets); null when unknown or not a speed camera. */
    val speedLimitKmh: Int? = null,
)

fun SpeedCamera.toDto() = SpeedCameraDto(id, type.name, point.latitude, point.longitude, speedLimitKmh)

/** @throws IllegalArgumentException on invalid coordinates. */
fun SpeedCameraDto.toDomain() = SpeedCamera(
    id = id,
    point = GeoPoint(lat, lon),
    type = SpeedCameraType.entries.firstOrNull { it.name == type } ?: SpeedCameraType.UNKNOWN,
    speedLimitKmh = speedLimitKmh,
)
